import { escapeHtml } from "./acrotohtml/escapeHtml";
import { renderTable } from "./doctohtml/renderTable";
import { DocSchema } from "./doctohtml/types";

export function buildSectionsFromDocx(schema: unknown): {
  headersHtml: string;
  sections: { id: string; name: string; html: string }[];
} {
  if (!schema || typeof schema !== "object") {
    return {
      headersHtml: "",
      sections: [],
    };
  }

  const docSchema = schema as DocSchema;

  if (!docSchema.Heading || !Array.isArray(docSchema.Heading)) {
    return {
      headersHtml: "",
      sections: [],
    };
  }

  if (!docSchema.Tables || !Array.isArray(docSchema.Tables)) {
    return {
      headersHtml: "",
      sections: [],
    };
  }

  const headersHtml = docSchema.Heading
    .map((h) => `<h1 class="test text-xl font-bold text-gray-900 text-center">${escapeHtml(h)}</h1>`)
    .join("");

  const sections = docSchema.Tables.map((table, index) => {
    let sectionName = `Section ${index + 1}`;

    if (table.TableHeading) {
      sectionName = table.TableHeading;
    } else if (table.TableRows.length > 0) {
      const firstRow = table.TableRows[0];
      if (firstRow.docXElements.length > 0) {
        const firstElement = firstRow.docXElements[0];
        if (firstElement.docXItems.length > 0) {
          const firstItem = firstElement.docXItems[0];
          if (firstItem.Value) {
            sectionName = firstItem.Value;
          }
        }
      }
    }

    return {
      id: table.TableId,
      name: sectionName,
      html: renderTable(table),
    };
  });

  return {
    headersHtml,
    sections,
  };
}


